export const MODULE_NAME = "Charts";

